import React from 'react';
import Message from 'components/Message';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';
import { AddScheduleButton } from '../../AddScheduleButton';
import messages from '../../Schedules.messages';
import './SchedulesEmpty.scss';

const { block, element } = bem('schedules-empty');

const SchedulesEmpty = ({ venueId, hasFilters, startDate }) => {
  if (hasFilters) {
    return (
      <section className={block()}>
        <Message as="div" className={element('text')} message={messages.board.empty.noFilteredSchedules} />
      </section>
    );
  }
  return (
    <section className={block()}>
      <Message as="div" className={element('header')} message={messages.board.empty.noSchedules} />
      <Message as="div" className={element('text')} message={messages.board.empty.addFirst} />
      <AddScheduleButton venueId={venueId} startDate={startDate} />
    </section>
  );
};

SchedulesEmpty.propTypes = {
  venueId: PropTypes.number,
  hasFilters: PropTypes.bool,
  startDate: PropTypes.instanceOf(Date),
};

export default SchedulesEmpty;
